import React, { useState } from 'react';

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Components
import TextField from '../../../../../components/inputs/input';
import Dropdown from '../../../../../components/inputs/dropdown';
import Upload from '../../../../../components/inputs/upload';
import Spinner from '../../../../../components/spinner';

// Models
import { subTypesFormat } from '../../../../../models/CashRegisterMovementEntity';
import { utils } from '../../../../../utils/utils';

// Services 
import CashRegisterService from '../../../../../services/cashRegisterService';
import FileService from '../../../../../services/fileService';

const DetailEgress = ({ onClose, open, cashRegisterMovement, setCashRegisterMovement, onSave, currencies }) => {
    const [previewImageUrl, setPreviewImageUrl] = useState('');
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleFileUpload = (event) => {
        setPreviewImageUrl(URL.createObjectURL(event.target.files[0]));
        setFiles(event.target.files);
    }
    
    const handleUpdateMovementFileUrl = async () => {
        try {
            if (files.length > 0) {
                setLoading(true);
                const fileUrl = await FileService.Upload(files[0]);
                
                await CashRegisterService.UpdateMovementFileUrl(cashRegisterMovement.id, fileUrl)
                .finally(() => {
                    setLoading(false);
                    setPreviewImageUrl('');
                    setCashRegisterMovement({
                        ...cashRegisterMovement,
                        fileUrl,
                    });
                    onSave();
                });
            }
        } catch (err) {
            setLoading(false);
            console.error(err)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='sm'
        >
            <DialogTitle id="alert-dialog-title">
                {cashRegisterMovement.subTypeFormat === subTypesFormat.Imprest ? `Egreso de ${subTypesFormat.Imprest}` : `Egreso de Caja${cashRegisterMovement.subTypeFormat ? ` (${cashRegisterMovement.subTypeFormat})` : ''}`}
            </DialogTitle>
            <DialogContent dividers>
                {loading && <Spinner lockScreen message='Actualizando Movimiento' />}
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <TextField
                            fullWidth
                            size='small'
                            name='user'
                            label='Usuario'
                            value={cashRegisterMovement.userEmail}
                            disabled
                        />
                    </Grid>
                    {
                        cashRegisterMovement.bankAccountInfo &&
                        <>
                            <Grid size={12}>
                                <TextField
                                    fullWidth
                                    size='small'
                                    name='bankAccountInfo'
                                    label='Cuenta bancaria'
                                    value={cashRegisterMovement.bankAccountInfo || ''}
                                    disabled
                                />
                            </Grid>
                            <Grid size={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    name="externalPrefix"
                                    label="Prefijo"
                                    value={cashRegisterMovement?.externalPrefix || ""}
                                    disabled
                                />
                            </Grid>
                            <Grid size={4}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    name="externaNumber"
                                    label="Numero Externo"
                                    value={cashRegisterMovement?.externaNumber || ""}
                                    disabled
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    disabled
                                    fullWidth
                                    size='small'
                                    name="externaDate"
                                    label="Fecha externo"
                                    value={utils.formatDate(cashRegisterMovement?.externaDate || '')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </>
                    }
                    <Grid size={3}>
                        <TextField
                            fullWidth
                            size='small'
                            name='cashType'
                            label='Tipo de efectivo'
                            value={cashRegisterMovement.cashTypeFormat}
                            disabled
                        />
                    </Grid>
                    <Grid size={3}>
                        <Dropdown
                            fullWidth
                            disabled
                            values={currencies}
                            size="small"
                            name="currency"
                            label="Moneda"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={cashRegisterMovement.currency}
                        />
                    </Grid>
                    <Grid size={6}>
                        <TextField
                            fullWidth
                            size='small'
                            name='amount'
                            label='Importe'
                            type='number'
                            value={cashRegisterMovement.amount} 
                            disabled
                        />
                    </Grid>
                    {
                        cashRegisterMovement.reason &&
                        <Grid size={12}>
                            <TextField
                                fullWidth
                                multiline
                                rows={5}
                                size='small'
                                name='reason'
                                label='Motivo'
                                value={cashRegisterMovement.reason || ' '}
                                disabled
                            />
                        </Grid>
                    }
                    <Grid size={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={5}
                            size='small'
                            name='observation'
                            label='Observación'
                            value={cashRegisterMovement.observation || ''} 
                            disabled
                        />
                    </Grid>
                    {
                        cashRegisterMovement.fileUrl
                        ? <Grid size={12}>
                            <a href={cashRegisterMovement.fileUrl} target='_blank' rel='noreferrer' style={{ marginLeft: "10px", marginTop: "15px", display: "flex", alignItems: "center" }}>
                                <img src={cashRegisterMovement.fileUrl} style={{ maxHeight: "200px", maxWidth: "200px", marginLeft: "5px" }} alt="" />
                            </a>
                        </Grid>
                        : <Grid container style={{ marginLeft: "15px", marginTop: "15px" }} size={12}>
                            <Grid size={6}>
                                <img src={previewImageUrl} style={{ maxHeight: "200px", maxWidth: "200px" }} alt="" />
                            </Grid>
                            <Grid size={6}>
                                <Upload
                                    hideLegend
                                    id="files-upload"
                                    accept=".jpg,.png,.jpeg,.bmp"
                                    text="Adjuntar Factura o Ticket"
                                    onChange={handleFileUpload}
                                    permittedExtensions={["image/png", "image/jpg", "image/jpeg", "image/bmp"]}
                                    fileLength={2}
                                />
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="primary"
                >
                    {
                        previewImageUrl ? "Cancelar" : "Cerrar"
                    }
                </Button>
                {
                    !cashRegisterMovement.fileUrl &&
                    <Button
                        onClick={handleUpdateMovementFileUrl}
                        color="primary"
                        variant="outlined"
                        autoFocus
                        disabled={!previewImageUrl}
                    >
                        Guardar
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
}

export default DetailEgress;